/**
 * Elevation constants — single source of truth for component elevations.
 * Keep in sync with the matching SCSS variables in src/styles/settings.scss
 * (no automated link yet; update both sides).
 *
 * Usage: import { ELEVATIONS } from '@/constants/elevations'
 */
export const ELEVATIONS = {
  snackbar: 1,
  snackbarToast: 3,
  card: 3,
  cardHover: 5,
  dialog: 4,
  navigationDrawer: 2,
  appBar: 0,
  menu: 4,
  expansionPanel: 3,
  table: 3,
  topNavigation: 2
} as const;

export type ElevationKey = keyof typeof ELEVATIONS;
